import { render, staticRenderFns } from "./AuthFooterV2Component.vue?vue&type=template&id=3dbc1d16&"
import script from "./AuthFooterV2Component.vue?vue&type=script&lang=js&"
export * from "./AuthFooterV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports